<article>
    <ng-container *ngIf="!settled">
        <app-spinner></app-spinner>
    </ng-container>

    <ng-container *ngIf="settled">
        <p id="code">404</p>
        <p>The page you have requested could not be found</p>
    </ng-container>
</article> 